class MainBlog extends HTMLElement {
    constructor() {
        super();

        const urlLastPart = window.location.href;
        const afterLastSlash = urlLastPart.substring(urlLastPart.lastIndexOf('/') + 1);
        const activeTabs = document.querySelectorAll('.main-blog__tab-link[data-blog=' + afterLastSlash + ']');
        activeTabs.forEach((activeTab) => {
            activeTab.classList.add('main-blog__tab-link--active');
        });
    }
}

customElements.define('main-blog', MainBlog);
